/**
 * 月日组件
 */
import React, { useState } from 'react';
import { DatePicker } from '@arco-design/web-react';
import dayjs from 'dayjs';

function MonthDatePicker(props) {
  const [hidePrev, setHidePrev] = useState(false);
  const [hideNext, setHideNext] = useState(false);

  return (
    <DatePicker
      format="MM-DD"
      hideNotInViewDates={true}
      showNowBtn={false}
      defaultValue={dayjs().valueOf()}
      disabledDate={(current) => {
        const year = new Date().getFullYear();
        return current.isBefore(dayjs(`${year}-01-01 00:00:00`)) || current.isAfter(dayjs(`${year}-12-31 23:59:59`));
      }}
      panelRender={(panelNode) => {
        return <div className={`cartx-month-date-picker ${hidePrev ? 'hide-prev' : ''} ${hideNext ? 'hide-next' : ''}`}>{panelNode}</div>;
      }}
      onPickerValueChange={(dateString, value) => {
        const [m] = dateString.split('-');
        if (m === '01') {
          setHidePrev(true);
        } else if (m === '12') {
          setHideNext(true);
        } else {
          setHidePrev(false);
          setHideNext(false);
        }
      }}
      // 覆盖配置
      {...props}
    />
  );
}

export default MonthDatePicker;
